import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              {contactData.description}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {contactData.items.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-5 text-center border border-background-200/60"
              >
                <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className={`${item.icon} text-lg text-accent-700`}></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">{item.label}</div>
                <div className="text-sm font-medium text-foreground-800 break-all">{item.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}